import React from 'react';
import { Button } from './Button';
import styled from '@emotion/styled';
import { useComponentTheme } from '../useComponentTheme';

/**
 * ### Available modes
 * * `DiningEatIn`: Eat In Button from Dining type Page
 * * `DiningTakeaway`: Takeaway Button from Dining type Page
 *
 * ### Example
 * ```
 default {
    ...
    CardButton: {
      DiningEatIn: {
        hideText: true,
        backgroundImage: 'https://picsum.photos/300',
        backgroundColor: 'black',
      },
      DiningTakeaway: {
        hideText: true,
        backgroundColor: 'black',
      }
    },
    ...
  }
 * ```
 * */

export const CardButton = ({ className, mode, children, ...rest }: mixed) => {
  const componentTheme = useComponentTheme(theme => theme.components.CardButton, mode);
  return (
    <Card className={className} componentTheme={componentTheme} {...rest}>
      {children}
    </Card>
  );
};

const Card = styled(Button)`
  ${({ componentTheme }) => componentTheme.hideText && 'color: transparent'};
  ${({ componentTheme }) =>
    componentTheme.backgroundImage &&
    `
    border: none;
    background: ${componentTheme.backgroundColor} url(${componentTheme.backgroundImage}) center center no-repeat;
    background-size: cover;

    &:hover,
    &:active,
    &:focus {
      color: transparent;
    }
  `};
  ${({ componentTheme }) =>
    componentTheme.backgroundColor &&
    `
    border: none;
    background-color: ${componentTheme.backgroundColor};
  `};
`;
